import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {LabelModule} from '../ellipsis-label/label.module';
import {LockIconConfig} from '../lock-icon/lock-icon-config.interface';
import {LockIconModule} from '../lock-icon/lock-icon.module';

@Component({
  selector: 'vdw-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, LabelModule, LockIconModule]
})
export class DialogHeaderComponent {
  public title = input.required<string>();
  public isLocked = input<boolean>();
  public lockIconConfig = input<LockIconConfig>();
  public backEvent = output<void>();
}
